import { render, staticRenderFns } from "./FeatureTourHelp.vue?vue&type=template&id=481c0488&scoped=true&"
import script from "./FeatureTourHelp.vue?vue&type=script&lang=js&"
export * from "./FeatureTourHelp.vue?vue&type=script&lang=js&"
import style0 from "./FeatureTourHelp.vue?vue&type=style&index=0&id=481c0488&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481c0488",
  null
  
)

export default component.exports